import React, { useEffect, Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { GetSeo, SignupSubmit } from "./Components/Services";

function Signup({ isModal, setShowSignup, setShowLogin, setShowVerify, setShowModalLogin }) {
  const location = useLocation();
  const { user_type } = useSelector(state => state);
  const navigate = useNavigate();
  const initialState = {
    loading: false,
    data: {
      mobile: location.state ? location.state.mobile : null,
      fullname: null,
      inviteCode: location.state ? location.state.inviteCode : null,
    },
  };

  const [state, setState] = useState(initialState);

  const validationForm = (form, params) => {
    let error = false;
    params.map(param => {
      if (!form[param]) {
        error = true;
      }
    });
    return error;
  };

  const SignupHandeler = (fullname, mobile, identifiercode, password) => {
    if (!fullname || !mobile || !password) {
      toast.error("لطفا ابتدا فرم را کامل کنید");
    } else {
      setState({ loading: true });
      SignupSubmit(mobile, fullname, identifiercode, password).then(result => {
        setState({
          ...state,
          loading: false,
          result: result,
        });
        if (result && result[0] === "Success") {
          if (!isModal) {
            navigate("/VeryfyCode", {
              state: { mobile: state.data.mobile },
            });
          }
          else {
            setShowSignup(false)
            setShowVerify({ status: true, mobile: state.data.mobile })
          }

        } else {
          toast.error("مشکلی پیش آمده");
        }
      });
    }
  };

  if (user_type) {
    if (!isModal) {
      return <Navigate to={"/User/Dashboard"} />
    }
    else {
      setShowModalLogin(false)
    }
  }
  return (
    <Fragment>
      {!isModal &&
        <Helmet>
          <title>نیکوتن | ثبت نام</title>
        </Helmet>
      }
      <div className={"main-login d-flex justify-content-center align-items-center " + (!isModal && "py-4 ")
        + (window.screen.width > 575 ? !isModal && "my-5" : "my-0")}>
        <div className="container-fluid px-3 px-md-5 d-n">
          <div className="d-flex justify-content-center">
            <div
              className={"rounded-11 login " + (!isModal && "part-padding")}
              style={{
                boxShadow: !isModal && "rgba(0, 0, 0, 0.12) 0px 0px 3px, rgba(0, 0, 0, 0.24) 0px 0px 5px",
                width: !isModal && "450px"
              }}
            >
              <div className="center">
                <div className="top mb-5 d-flex flex-column align-items-center justify-content-center">
                  <Link to={"/"}>
                    <img
                      className="img"
                      style={{ width: window.screen.width > 575 ? "150px" : "100px" }}
                      src={window.origin + "/WebSide/assets/images/logo.png"}
                      alt="nikotan | نیکوتن"
                    />
                  </Link>
                  <img
                    style={{ width: window.screen.width > 575 ? "100%" : "80%" }}
                    className="mt-1"
                    src={window.origin + "/WebSide/assets/images/sam.png"}
                  />
                </div>
                <div className="form-group login-form-group mx-auto">
                  <p className="h6 mb-2" style={{ color: "#404040" }}>
                    نام و نام خانوادگی خود را وارد نمایید
                  </p>
                  <div className="inputt-group">
                    <input
                      style={{ borderRadius: "10px" }}
                      className="form-control mb-3"
                      type="text"
                      value={state.data && state.data.fullname}
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, fullname: e.target.value },
                        });
                      }}
                      placeholder="نام و نام خانوادگی"
                    />
                    <p className="h6 mb-2" style={{ color: "#404040" }}>
                      شماره موبایل خود را وارد نمایید
                    </p>
                    <input
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          SignupHandeler(
                            state.data && state.data.mobile,
                            state.data && state.data.fullname,
                            state.data && state.data.inviteCode,
                            state.data && state.data.password
                          );
                        }
                      }}
                      className="form-control mb-3"
                      type="text"
                      value={location.state && location.state.mobile}
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, mobile: e.target.value },
                        });
                      }}
                      placeholder="شماره مویایل "
                      style={{ borderRadius: "10px" }}
                    />
                    <p className="h6 mb-2" style={{ color: "#404040" }}>
                      رمز عبور را وارد کنید
                    </p>
                    <input
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          SignupHandeler(
                            state.data && state.data.mobile,
                            state.data && state.data.fullname,
                            state.data && state.data.inviteCode,
                            state.data && state.data.password
                          );
                        }
                      }}
                      className="form-control mb-3"
                      type="text"
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, password: e.target.value },
                        });
                      }}
                      placeholder="رمز عبور"
                      style={{ borderRadius: "10px" }}
                    />
                    <p className="h6 mb-2" style={{ color: "#404040" }}>
                      کد دعوت را وارد کنید (اختیاری)
                    </p>
                    <input
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          SignupHandeler(
                            state.data && state.data.mobile,
                            state.data && state.data.fullname,
                            state.data && state.data.inviteCode,
                            state.data && state.data.password
                          );
                        }
                      }}
                      className="form-control mb-3"
                      type="text"
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, inviteCode: e.target.value },
                        });
                      }}
                      placeholder="به عنوان مثال : niko-224"
                      style={{ borderRadius: "10px" }}
                    />
                  </div>
                </div>
                <button
                  onClick={() =>
                    SignupHandeler(
                      state.data && state.data.mobile,
                      state.data && state.data.fullname,
                      state.data && state.data.inviteCode,
                      state.data && state.data.password
                    )
                  }
                  className={`btn btn-red-v2 w-100 h6 mb-3 text-white ${state.loading ? "disabled" : null} `}
                  style={{ borderRadius: "10px" }}
                >
                  {state.loading ? "در حال پردازش..." : "ثبت نام"}
                </button>
                <p className="text-center mb-2" style={{ color: "#404040" }}>
                  <Link
                    to={"/RulesSite"}
                    className="ms-2 fw-bold"
                    style={{ color: "#E42A3F" }}
                  >
                    قوانین سایت &nbsp;
                  </Link>
                  و
                  <Link
                    to={"/Privacy"}
                    className=" ms-2 fw-bold"
                    style={{ color: "#E42A3F" }}
                  >
                    حریم خصوصی &nbsp;
                  </Link>
                  را می پذیرم
                </p>
                <p className="text-center" style={{ color: "#404040" }}>
                  پیش از این ثبت نام کرده اید؟
                  {!isModal
                    ?
                    <Link
                      to={"/check"}
                      className=" ms-2 fw-bold"
                      style={{ color: "#E42A3F" }}
                    >
                      صفحه ورود
                    </Link>
                    :
                    <Link
                      onClick={() => {
                        setShowSignup(false)
                        setShowLogin(true)
                      }}
                      className=" ms-2 fw-bold"
                      style={{ color: "#E42A3F" }}
                    >
                      صفحه ورود
                    </Link>
                  }

                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Signup;
